const actions = [
  { value: 'required', label: 'Required' },
  { value: 'alert', label: 'Alert' },
  { value: 'optional', label: 'Optional' },
  { value: 'none', label: 'None' }
]

const values = actions.map(action => action.value)

function normalize (value) {
  return values.indexOf(value) > -1 ? value : 'none'
}

function label (value) {
  const normalized = normalize(value)
  const action = actions.find(item => item.value === normalized)
  return action.label
}

function enabled (currentUser) {
  return !!(currentUser && (
    currentUser.two_factor_enabled ||
    currentUser.google2fa_enabled
  ))
}

function requiresSetup (currentUser) {
  return !!(
    currentUser &&
    normalize(currentUser.two_fa_action) === 'required' &&
    !enabled(currentUser)
  )
}

function shouldAlert (currentUser) {
  return !!(
    currentUser &&
    normalize(currentUser.two_fa_action) === 'alert' &&
    !enabled(currentUser)
  )
}

function shouldOffer (currentUser) {
  return !!(
    currentUser &&
    normalize(currentUser.two_fa_action) === 'optional' &&
    !enabled(currentUser)
  )
}

export default {
  actions,
  normalize,
  label,
  enabled,
  requiresSetup,
  shouldAlert,
  shouldOffer
}
